
export const PageNotFound = () => {
    return (
        <>
            <h1>Sorry page not found.</h1>
            <p><a href="/">Go Home</a></p>
        </>
    );
}